export default __webpack_public_path__ + "images/baseline-info.svg";